import { apiClient } from "../client";

export interface Skill {
  id: number;
  name: string;
  slug: string;
  status: boolean;
}

export interface Language {
  id: number;
  name: string;
  code: string;
  is_active: boolean;
  sort_order: number;
}

/** Country / state / city lookup row. Upstream is loosely typed — keep permissive. */
export interface LocationItem {
  id: number;
  name: string;
  [key: string]: unknown;
}

/** India's id in the upstream country table (GET /get-country-list). */
export const INDIA_COUNTRY_ID = 101;

/** Small, rarely-changing reference lists (safe to cache aggressively). */
export const lookups = {
  skills: () => apiClient.get<Skill[]>("/skills"),
  languages: () => apiClient.get<Language[]>("/languages"),

  countries: () => apiClient.get<unknown>("/get-country-list"),

  /** States for a country (defaults to India). */
  states: (country_id: number = INDIA_COUNTRY_ID) =>
    apiClient.post<unknown>("/get-state-list", { country_id }),

  /** Cities for a state. */
  cities: (state_id: number) => apiClient.post<unknown>("/get-city-list", { state_id }),
};
